// directives/verifyClick.js
import { verifyAndIntercept } from '@/utils/auth'

/**
 * v-verify-click 指令
 * 用法: <button v-verify-click="handleClick">点击</button>
 * 点击时会先验证登录状态，验证通过后才执行绑定的方法
 */
export default {
    bind(el, binding, vnode) {
        el._verifyClickHandler = async (event) => {
            // 阻止原始事件
            event.stopPropagation()

            // 验证登录状态
            const isValid = await verifyAndIntercept()

            if (isValid) {
                // 验证通过，执行绑定的方法
                if (typeof binding.value === 'function') {
                    binding.value.call(vnode.context, event)
                }
            }
        }

        el.addEventListener('click', el._verifyClickHandler)
    },

    unbind(el) {
        if (el._verifyClickHandler) {
            el.removeEventListener('click', el._verifyClickHandler)
            delete el._verifyClickHandler
        }
    }
}
